/* Design 2026 — Produktseite.
   1. Beschreibung in aufklappbare Abschnitte zerlegen (Vorbild tildaandtheo.de)
   2. Icons an allen Abschnitten (Vorbild lyllevenn.de)
   3. Infospalte läuft neben der Bildstrecke mit, auch wenn sie höher als der Bildschirm ist
   4. Variantenwechsel scrollt zum passenden Bild der Strecke
   5. Kaufleiste, sobald der Warenkorb-Button aus dem Bild ist
   6. „Weitere Bewertungen anzeigen"
   Ohne JavaScript bleibt die Seite vollständig lesbar — die Produktdaten
   werden nicht verändert, nur ihre Darstellung. */
(function () {
  'use strict';

  var ICONS = {
    herz: '<path d="M12 20s-7.5-4.6-7.5-10A4.3 4.3 0 0 1 12 7.4 4.3 4.3 0 0 1 19.5 10c0 5.4-7.5 10-7.5 10z"/>',
    lineal: '<path d="M3 15.5 15.5 3l5.5 5.5L8.5 21z"/><path d="m7 11.5 2 2M9.5 9l1.5 1.5M12 6.5l2 2M14.5 4l1.5 1.5"/>',
    blatt: '<path d="M5 19c0-8 5-13 15-14-1 10-6 15-14 15"/><path d="M5 19 12 12"/>',
    stern: '<path d="M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.9l-5.2 2.7 1-5.8-4.3-4.1 5.9-.9z"/>',
    haken: '<circle cx="12" cy="12" r="8.5"/><path d="m8.5 12 2.5 2.5 4.5-5"/>',
    paket: '<path d="M3.5 7.5 12 3.5l8.5 4v9L12 20.5l-8.5-4z"/><path d="M3.5 7.5 12 11.5l8.5-4M12 11.5v9"/>',
    zurueck: '<path d="M9 7 4.5 11.5 9 16"/><path d="M4.5 11.5H15a4.5 4.5 0 0 1 0 9h-3"/>',
    schild: '<path d="M12 3.5 19 6v5.5c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6z"/><path d="m9 12 2 2 4-4"/>',
    frage: '<circle cx="12" cy="12" r="8.5"/><path d="M9.6 9.5a2.5 2.5 0 1 1 3.4 2.3c-.6.3-1 .8-1 1.5v.7"/><circle cx="12" cy="16.8" r=".6"/>',
    geschenk: '<path d="M4 10h16v10H4zM3 7h18v3H3zM12 7v13"/><path d="M12 7C10 3 7 4 8 6.5 9 7 12 7 12 7zm0 0c2-4 5-3 4-.5C15 7 12 7 12 7z"/>',
    info: '<circle cx="12" cy="12" r="8.5"/><path d="M12 11v5.5"/><circle cx="12" cy="8" r=".6"/>'
  };

  // Schreibweisen aus den 406 Beschreibungen → einheitlicher Titel + Icon.
  // Reihenfolge zählt: der erste Treffer gewinnt.
  var TITEL = [
    [/GPSR|HERSTELLERANGABEN|^RECHTLICHES$/, 'Produktsicherheit', 'schild'],
    [/WIDERRUFSBELEHRUNG/, 'Rückgabe & Widerruf', 'zurueck'],
    [/^MA(SS|ß)E\s*&\s*MATERIAL/, 'Maße & Material', 'lineal'],
    [/^MA(SS|ß)E\s*&\s*DETAILS/, 'Maße & Details', 'lineal'],
    [/^MA(SS|ß)E\b|MA(SS|ß)E$|^FÜLLMENGE/, 'Maße', 'lineal'],
    [/GR(Ö|O)(SS|ß)E/, 'Größen', 'lineal'],
    [/^MATERIAL(\s*-?\s*UND PFLEGEHINWEISE|\s*&\s*PFLEGE)|^PRODUKTDETAILS & PFLEGE/, 'Material & Pflege', 'blatt'],
    [/^MATERIAL(IEN)?\b|^NATURPRODUKT/, 'Material', 'blatt'],
    [/^PFLEGE/, 'Pflegehinweise', 'stern'],
    [/PERSONALISIERUNG|GRAVUR|MOTIV|SPRUCH AUSWÄHLEN|TEXT AUSWÄHLEN|SYMBOL|EIGENE GRAFIK|NAME & DATUM|KOMMENTARFELD|^SO GEHT|DEINE MÖGLICHKEITEN|DU HAST ZWEI OPTIONEN/, 'Personalisierung', 'herz'],
    [/FARBEN|^FARBE$|SCHRIFTFARBE/, 'Farben', 'info'],
    [/^WICHTIGE (HINWEISE|INFORMATIONEN)$|^WICHTIGER HINWEIS|^HINWEISE?\b|LIEFERZEIT|RECHTZEITIG|^VERSANDPAUSCHALE/, 'Wichtige Hinweise', 'haken'],
    [/UNIKAT/, 'Details', 'info'],
    [/^BESONDERHEITEN|^DETAILS|^PRODUKTINFORMATION|^PRODUKTDETAILS|^WEITERE DETAILS|^INNENLEBEN|^INHALT DES SETS|MERKMALE|WAS .* BESONDERS MACHT|^QUALITÄT/, 'Details', 'info'],
    [/^ZUBEHÖR|^DEKO$/, 'Zubehör', 'paket'],
    [/^BESTELLVARIANTEN$|VARIANTEN|^WÄHLBAR MIT$|AUFDRUCK|^ZWEI OPTIONEN|WIE FOLGT BESTELLT/, 'Varianten', 'info'],
    [/GESCHENK|^FÜR WEN|^ANLASS$|^PASSEND ZU|^PERFEKT ALS|^DIESE KERZE IST PERFEKT/, 'Als Geschenk', 'geschenk'],
    [/^VERWENDUNG$|VIELSEITIG EINSETZBAR|^WOFÜR|EIGNET SICH/, 'Verwendung', 'info'],
    [/INSPIRATION|GIBT ES HIER|^ZUGEHÖRIG/, 'Passend dazu', 'geschenk'],
    [/ÜBER JELLIES ?DESIGN|^JELLIESDESIGN/, 'Über Jellies Design', 'herz']
  ];

  // Feste Abschnitte aus product.json (Tab-Blöcke) → Icon
  var FEST = {
    'Versand & Lieferung': 'paket',
    'Rückgabe & Widerruf': 'zurueck',
    'Produktsicherheit': 'schild',
    'Noch Fragen?': 'frage'
  };

  // Überschriften, die nur eine andere Schreibweise des Titels sind
  var SYNONYM = /^(WICHTIGE (HINWEISE|INFORMATIONEN)|WICHTIGER HINWEIS|HINWEISE?|PFLEGE(HINWEISE)?|MATERIAL(IEN)?|MA(SS|ß)E|DETAILS|PRODUKTDETAILS|FARBEN?|ZUBEHÖR|VERWENDUNG|PERSONALISIERUNG|GRAVUR|BESONDERHEITEN|BESTELLVARIANTEN|HERSTELLERANGABEN.*|GPSR.*)$/;
  function vergleich(t) {
    return t.toLowerCase().replace(/ß/g, 'ss').replace(/[^a-zäöü0-9]/g, '');
  }

  function icon(name) {
    return '<span class="jd-icon" aria-hidden="true"><svg viewBox="0 0 24 24">' + (ICONS[name] || ICONS.info) + '</svg></span>';
  }

  function sauber(text) {
    return text.replace(/\s+/g, ' ').replace(/^[^\p{L}\d"„]+/u, '').replace(/[:\s]+$/, '').trim();
  }

  function istVersal(t) {
    return /[A-ZÄÖÜ]/.test(t) && t === t.toUpperCase();
  }

  // Ist dieser (kurze) Text eine Zwischenüberschrift?
  function ueberschrift(text, el) {
    var t = text.replace(/\s+/g, ' ').trim();
    if (t.length < 3 || t.length > 60) return false;
    if (/^[-–•]/.test(t)) return false;
    if (/[.!?]$/.test(t)) return false;            // ganze Sätze sind Text, keine Überschrift
    if (el && /^H[2-6]$/.test(el.tagName)) return true;
    if (/:$/.test(t)) return true;
    if (istVersal(sauber(t)) && sauber(t).length >= 4) return true;
    if (el && el.children.length === 1 && /^(STRONG|B)$/.test(el.children[0].tagName) &&
        el.children[0].textContent.trim() === t) return true;
    return false;
  }

  function titelFuer(roh) {
    var t = sauber(roh);
    var key = t.toUpperCase().replace(/&AMP;/g, '&');
    for (var i = 0; i < TITEL.length; i++) {
      if (TITEL[i][0].test(key)) return { titel: TITEL[i][1], icon: TITEL[i][2], bekannt: true };
    }
    if (istVersal(t) && t.indexOf(' ') === -1) t = t.charAt(0) + t.slice(1).toLowerCase();
    return { titel: t, icon: 'info', versal: istVersal(t) };
  }

  // „<p>PERSONALISIERUNGSOPTIONEN: Graviere Namen …</p>" → Überschrift + Text
  function versalPraefix(p) {
    var erster = p.firstChild;
    if (!erster || erster.nodeType !== 3) return null;
    var m = erster.textContent.match(/^\s*([A-ZÄÖÜß][A-ZÄÖÜß&\- ]{3,40}):\s*(\S[\s\S]*)$/);
    if (!m || !istVersal(m[1])) return null;
    var rest = document.createElement('p');
    erster.textContent = m[2];
    while (p.firstChild) rest.appendChild(p.firstChild);
    return { kopf: m[1], rest: rest };
  }

  // „<p>MAßE & MATERIAL:<br>- …</p>" → Überschrift + eigener Absatz
  function ersteZeileAbtrennen(p) {
    var praefix = versalPraefix(p);
    if (praefix) return praefix;
    var br = p.querySelector('br');
    if (!br || br.parentNode !== p) return null;
    var kopf = '';
    var n = p.firstChild;
    while (n && n !== br) { kopf += n.textContent; n = n.nextSibling; }
    if (!ueberschrift(kopf, null)) return null;
    var rest = document.createElement('p');
    n = br.nextSibling;
    while (n) { var weiter = n.nextSibling; rest.appendChild(n); n = weiter; }
    return { kopf: kopf, rest: rest };
  }

  function zerlegen(box) {
    var knoten = Array.prototype.slice.call(box.childNodes);
    var teile = [];          // [{kopf, inhalt: [nodes]}]; kopf null = Einleitung
    var aktuell = { kopf: null, inhalt: [] };
    teile.push(aktuell);

    knoten.forEach(function (n) {
      if (n.nodeType === 3 && !n.textContent.trim()) return;
      var text = (n.textContent || '').trim();
      if (n.nodeType === 1 && /^[-–—_*=~\s]{3,}$/.test(text)) return;   // Trennzeilen
      if (n.nodeType === 1 && !text && !n.querySelector('img,iframe,video')) return;

      if (n.nodeType === 1 && ueberschrift(text, n) && n.querySelectorAll('br').length === 0) {
        if (aktuell === teile[0] && !teile[0].inhalt.length && !titelFuer(text).bekannt) {
          teile[0].inhalt.push(n);   // Produktname als Kopfzeile der Einleitung
          return;
        }
        aktuell = { kopf: text, inhalt: [] };
        teile.push(aktuell);
        return;
      }
      if (n.nodeType === 1 && n.tagName === 'P') {
        var geteilt = ersteZeileAbtrennen(n);
        if (geteilt) {
          aktuell = { kopf: geteilt.kopf, inhalt: geteilt.rest.textContent.trim() ? [geteilt.rest] : [] };
          teile.push(aktuell);
          return;
        }
      }
      aktuell.inhalt.push(n);
    });

    var abschnitte = teile.filter(function (t) { return t.kopf && t.inhalt.length; });
    if (!abschnitte.length) return null;

    // gleiche Titel zusammenführen („Wichtige Hinweise" und „Wichtige Informationen")
    var nachTitel = {};
    var reihenfolge = [];
    abschnitte.forEach(function (a) {
      var t = titelFuer(a.kopf);
      if (!nachTitel[t.titel]) { nachTitel[t.titel] = { t: t, inhalt: [] }; reihenfolge.push(t.titel); }
      // Sagt die Original-Überschrift mehr als der einheitliche Titel
      // („Nach dem Kauf im Kommentarfeld angeben"), bleibt sie als Unterkopf stehen
      var roh = sauber(a.kopf);
      if (t.bekannt && !SYNONYM.test(roh.toUpperCase()) && vergleich(roh) !== vergleich(t.titel)) {
        var u = document.createElement('p');
        u.className = 'jd-unterkopf';
        u.textContent = istVersal(roh) ? roh.charAt(0) + roh.slice(1).toLowerCase() : roh;
        a.inhalt.unshift(u);
      }
      nachTitel[t.titel].inhalt = nachTitel[t.titel].inhalt.concat(a.inhalt);
    });

    // Einleitung bleibt in der Box, alles andere wandert in die Abschnitte
    box.innerHTML = '';
    teile[0].inhalt.forEach(function (n) { box.appendChild(n); });
    // Überschriften ohne Inhalt (z. B. direkt aufeinanderfolgend) als Text erhalten
    teile.forEach(function (t) {
      if (t.kopf && !t.inhalt.length && teile[0] !== t) {
        var p = document.createElement('p'); p.textContent = t.kopf; box.appendChild(p);
      }
    });
    return reihenfolge.map(function (k) { return nachTitel[k]; });
  }

  function abschnittBauen(a, nr, pfeil) {
    var id = 'jd-abschnitt-' + nr;
    var block = document.createElement('div');
    block.className = 'product-block product-block--tab jd-abschnitt';
    block.innerHTML =
      '<div class="collapsibles-wrapper collapsibles-wrapper--border-bottom">' +
      '<button type="button" class="label collapsible-trigger collapsible-trigger-btn collapsible-trigger-btn--borders collapsible--auto-height' +
      (a.t.versal ? ' jd-versal' : '') + '" aria-controls="' + id + '"></button>' +
      '<div id="' + id + '" class="collapsible-content collapsible-content--all">' +
      '<div class="collapsible-content__inner rte"></div></div></div>';
    var btn = block.querySelector('button');
    btn.appendChild(document.createTextNode(a.t.titel));
    if (pfeil) btn.appendChild(pfeil.cloneNode(true));
    btn.setAttribute('data-jd-icon', a.t.icon);
    var inner = block.querySelector('.collapsible-content__inner');
    a.inhalt.forEach(function (n) { inner.appendChild(n); });
    return block;
  }

  function beschreibung() {
    var box = document.querySelector('[data-jd-beschreibung]');
    if (!box) return;
    var meta = box.closest('.product-single__meta') || document;
    var abschnitte = zerlegen(box);
    var block = box.closest('.product-block');
    var pfeil = meta.querySelector('.collapsible-trigger .collapsible-trigger__icon');

    if (abschnitte && block) {
      var titel = abschnitte.map(function (a) { return a.t.titel; });
      var anker = block;
      abschnitte.forEach(function (a, i) {
        var neu = abschnittBauen(a, i, pfeil);
        anker.parentNode.insertBefore(neu, anker.nextSibling);
        anker = neu;
      });
      // feste Abschnitte, die die Beschreibung schon selbst mitbringt, nicht doppelt zeigen
      meta.querySelectorAll('.product-block--tab:not(.jd-abschnitt) .collapsible-trigger').forEach(function (b) {
        if (titel.indexOf(b.textContent.trim()) !== -1) b.closest('.product-block').style.display = 'none';
      });
    }
    if (!box.textContent.trim() && block) block.classList.add('jd-ohne-einleitung');

    // Icons an alle Abschnitte
    meta.querySelectorAll('.product-block--tab .collapsible-trigger').forEach(function (b) {
      if (b.querySelector('.jd-icon')) return;
      var name = b.getAttribute('data-jd-icon') || FEST[b.textContent.trim()] || 'info';
      b.insertAdjacentHTML('afterbegin', icon(name));
    });

    if (window.theme && theme.collapsibles) theme.collapsibles.init(meta);
  }

  // Infospalte läuft mit — Logik wie <sticky-scroller> des Themes: ist die
  // Spalte höher als der Bildschirm, scrollt sie erst durch und bleibt dann stehen.
  function infospalte() {
    var el = document.querySelector('.jd-infospalte');
    if (!el || !document.querySelector('[data-jd-bildstrecke]')) return;
    var mq = window.matchMedia('(min-width: 769px)');
    var start = 0, aktuell = 0, letztesY = window.scrollY, laeuft = false;

    function neu() {
      el.style.removeProperty('top');
      if (!mq.matches) return;
      start = parseInt(getComputedStyle(el).top, 10) || 0;
      aktuell = start;
      lage();
    }
    function lage() {
      if (!mq.matches) { el.style.removeProperty('top'); return; }
      var h = el.getBoundingClientRect().height;
      var minTop = h - window.innerHeight + 20;
      aktuell += letztesY - window.scrollY;
      aktuell = Math.min(Math.max(aktuell, -minTop), start);
      letztesY = window.scrollY;
      el.style.top = Math.round(aktuell) + 'px';
    }
    window.addEventListener('scroll', function () {
      if (laeuft) return;
      laeuft = true;
      requestAnimationFrame(function () { lage(); laeuft = false; });
    }, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(neu).observe(el);
    mq.addEventListener('change', neu);
    neu();
  }

  function variantenbild() {
    var strecke = document.querySelector('[data-jd-bildstrecke]');
    if (!strecke) return;
    document.addEventListener('variant:change', function (e) {
      var v = e.detail && e.detail.variant;
      var id = v && v.featured_media && v.featured_media.id;
      if (!id || !window.matchMedia('(min-width: 769px)').matches) return;
      var fig = strecke.querySelector('[data-media-id="' + id + '"]');
      if (!fig) return;
      var r = fig.getBoundingClientRect();
      if (r.top >= 0 && r.bottom <= window.innerHeight) return;
      window.scrollTo({ top: window.scrollY + r.top - 160, behavior: 'smooth' });
    });
  }

  function kaufleiste() {
    var knopf = document.querySelector('.product-single__meta [data-add-to-cart]');
    if (!knopf || !('IntersectionObserver' in window)) return;
    var titel = document.querySelector('.product-single__title');
    var preis = document.querySelector('.product-single__meta .product__price');
    var bild = document.querySelector('[data-jd-bildstrecke] img, .product__main-photos img');

    var leiste = document.createElement('div');
    leiste.className = 'jd-kaufleiste';
    leiste.setAttribute('aria-hidden', 'true');
    leiste.innerHTML =
      '<div class="jd-kaufleiste__innen page-width">' +
      (bild ? '<img class="jd-kaufleiste__bild" alt="" width="48" height="48">' : '') +
      '<div class="jd-kaufleiste__text"><span class="jd-kaufleiste__titel"></span>' +
      '<span class="jd-kaufleiste__preis"></span></div>' +
      '<button type="button" class="btn jd-kaufleiste__btn" tabindex="-1">In den Warenkorb</button></div>';
    if (bild) leiste.querySelector('img').src = bild.currentSrc || bild.src;
    leiste.querySelector('.jd-kaufleiste__titel').textContent = titel ? titel.textContent.trim() : '';
    function preisSetzen() {
      leiste.querySelector('.jd-kaufleiste__preis').textContent = preis ? preis.textContent.replace(/\s+/g, ' ').trim() : '';
    }
    preisSetzen();
    document.addEventListener('variant:change', function () { setTimeout(preisSetzen, 50); });
    document.body.appendChild(leiste);

    // Pflichtfelder zuerst: leeres Personalisierungsfeld → dorthin scrollen statt bestellen
    leiste.querySelector('button').addEventListener('click', function () {
      var meta = knopf.closest('.product-single__meta');
      var leer = Array.prototype.find.call(
        meta.querySelectorAll('input[required], textarea[required], select[required]'),
        function (f) { return !f.value && f.offsetParent !== null; });
      var ziel = leer || knopf;
      window.scrollTo({ top: window.scrollY + ziel.getBoundingClientRect().top - window.innerHeight / 3, behavior: 'smooth' });
      if (leer) setTimeout(function () { leer.focus({ preventScroll: true }); }, 400);
      else if (!knopf.disabled) knopf.click();
    });

    new IntersectionObserver(function (eintraege) {
      var e = eintraege[0];
      var zeigen = !e.isIntersecting && e.boundingClientRect.top < 0;
      leiste.classList.toggle('is-sichtbar', zeigen);
      leiste.setAttribute('aria-hidden', zeigen ? 'false' : 'true');
      leiste.querySelector('button').tabIndex = zeigen ? 0 : -1;
    }).observe(knopf);
  }

  function bewertungen() {
    var btn = document.querySelector('[data-jd-bewertungen-mehr]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      document.querySelector('[data-jd-bewertungen]').classList.add('is-alle');
      btn.remove();
    });
  }

  // für pruefe-beschreibungen.mjs (Prüflauf über alle Produkte)
  window.jdBeschreibung = { zerlegen: zerlegen, titelFuer: titelFuer };

  function los() {
    [beschreibung, infospalte, variantenbild, kaufleiste, bewertungen].forEach(function (f) {
      try { f(); } catch (err) { if (window.console) console.warn('jd-produktseite', f.name, err); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', los);
  else los();
})();
